import { Fragment, useEffect, useState } from 'react';
import { ArrowRight } from 'react-feather';
import { Button } from 'reactstrap';
import { ExploreMore, Simple, SimpleText, Upto } from '../../../../constants';
import { dynamicImage } from '../../../../utils';
import CommonModal from '../common/CommonModal';
import { Image } from '../../../../coreComponents/Image';

import { ReactNode } from 'react';

interface SimpleModalProps {
  children: ReactNode;
  isOpen: boolean;
  close: () => void;
  size?: string;
  centered?: boolean;
}

const SimpleModal = ({
  children,
  isOpen,
  close,
  size,
  centered = false,
}: SimpleModalProps) => {
  // const [modal, setModal] = useState(false);
  // const toggle = () => setModal(!modal);

  const data = { isOpen: isOpen, close: close, toggler: close, size: size, centered: centered };

  return (
    <Fragment>
      {/* <Button color="secondary" onClick={close}>
        {Simple}
      </Button> */}
      <CommonModal modalData={data}>
        <div className="modal-toggle-wrapper">
          {/* <h5>
            {Upto}
            <strong className="txt-danger">{"85% OFF"}</strong>
            {SimpleText}
          </h5>
          <div className="modal-img">
            <Image src={dynamicImage(`gif/online-shopping.gif`)} alt="online-shopping" />
          </div>
          <p className="text-sm-center">{"Our difficulty in finding regular clothes that was of great quality, comfortable, and didn't impact the environment given way to Creatures of Habit."}</p>
          */}
          {children}
          {/* <Button
            color="primary"
            className="d-flex align-items-center gap-2 text-light ms-auto"
            onClick={close}
          >
            {ExploreMore} <ArrowRight />
          </Button> */}
        </div>
      </CommonModal>
    </Fragment>
  );
};
export default SimpleModal;
